import { useCallback } from 'react';
import { useAssessmentsPaths } from '../hooks/useAssessmentsPaths';
import {
  initializeAssessmentsPendo,
  isAssessmentsPendoReady,
  trackAssessmentsPendoEvent,
} from './assessmentsPendoUtils';

/**
 * Assessments counterpart of usePendo: tracks an event, re-initializing Pendo first when the
 * session is missing or anonymous. Ids come from the URL.
 */
export const useAssessmentsPendoEvents = () => {
  const { tenantId, surveyEventId } = useAssessmentsPaths();

  const trackEvent = useCallback(
    async (eventName: string, eventData: Record<string, string> = {}) => {
      try {
        if (!isAssessmentsPendoReady()) {
          console.log('Re-initializing Assessments Pendo before tracking event');
          await initializeAssessmentsPendo({ tenantId, surveyEventId });
        }

        trackAssessmentsPendoEvent(eventName, eventData);
      } catch (error) {
        console.error('Error tracking Assessments Pendo event');
      }
    },
    [tenantId, surveyEventId],
  );

  return { trackEvent };
};
